import React from "react";
import OrderTaskForm from "./OrderTaskForm";

// Tarea «Resolver observación» (actor PICKING) — FORMCODE ELOBS
const CONFIG = {
  stage: 0,
  title: "Resolver observación",
  intro: "El pedido quedó observado en la preparación. Resuélvelo o cancélalo.",
  sections: ["pedido", "productos", "montos", "cliente", "entrega", "facturacion"],
  noteLabel: "Qué pasó con el pedido",
  checklist: [
    "Confirma con el cliente si hace falta (teléfono / WhatsApp).",
    "Si ya se puede preparar, marca Resuelto: vuelve a Preparar pedido.",
    "Si no se puede atender, cancela el pedido.",
  ],
  optionHints: {
    "Resuelto": "Vuelve a Preparar pedido.",
    "Cancelar pedido": "Termina el flujo sin entrega.",
  },
};

export default function ElevaxResolverObservacion(props) {
  return <OrderTaskForm {...props} config={CONFIG} />;
}
